<div class="panel___content no-padding" style="margin-top: 0px;">
    <div style="margin-left: 39%;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
    </div>
    <div *ngIf="favouriteId>0">
        <span style="font-weight: 600">Favourite Name : {{favouriteName}}</span>
    </div>
    <div>
      <i *ngIf="!loading && !showBar" class="material-icons" (click)="ShowHidefield()" style="cursor: pointer; transform: scale(1) rotate(90deg); color: #428bca;">
        forward
      </i>
      <i *ngIf="!loading && showBar" class="material-icons" (click)="ShowHidefield()" style="cursor: pointer; transform: scale(1) rotate(270deg); color: #428bca;">
        forward
      </i>
      <div class="search-options-cell" *ngIf="!loading && showBar">
        <button *ngIf="showBar" (click)="OpenOrderDilog()" class="button button--primary" style="height: 50px;">
          <span class="button__text">Set Column Order</span>
        </button>
        <div *ngIf="showBar" style="display: flex; flex-direction: row; width: 80%;">
          <div class="input-container addsapce">
            <span class="label" style="color: black; width: 70px;">Show/Hide</span>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="Make" (change)="changeCheckbox(Make, 'Make',3 )" style="margin-left: 15px;">
              Make
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="assetType" (change)="changeCheckbox(assetType, 'AssetType', 4 )" style="margin-left: 15px;">
              Asset Type
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Type" (change)="changeCheckbox(Type, 'AssetDefinition',5 )" style="margin-left: 15px;">
              Asset Definition
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="SerialNo" (change)="changeCheckbox(SerialNo, 'SerialNo',6 )" style="margin-left: 15px;">
              SerialNo
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="AltSerialNo" (change)="changeCheckbox(AltSerialNo, 'AdditionalSerial',7 )" style="margin-left: 15px;">
              Alt. Serial
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="IMPBudget" (change)="changeCheckbox(IMPBudget, 'ImpBudget', 8 )" style="margin-left: 15px;">
              Imp.Budget
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Life" (change)="changeCheckbox(Life, 'Life', 9 )" style="margin-left: 15px;">
              Life
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="Residual" (change)="changeCheckbox(Residual, 'Residual', 10 )" style="margin-left: 15px;">
              Residual
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="TotalLife" (change)="changeCheckbox(TotalLife, 'TotalLife', 11 )" style="margin-left: 15px;">
              Total Life
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="ReplacementDate" (change)="changeCheckbox(ReplacementDate, 'RemovelDate', 12 )" style="margin-left: 15px;">
              Replace Date
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="Status" (change)="changeCheckbox(Status, 'Status', 13 )" style="margin-left: 15px;">
              Status
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="WarantyStatus" (change)="changeCheckbox(WarantyStatus, 'WarrantyStatus', 14 )" style="margin-left: 15px;">
              Warranty Status
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="BuildNo" (change)="changeCheckbox(BuildNo, 'BuildNo', 15 )" style="margin-left: 15px;">
              Build No
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="NextInspection" (change)="changeCheckbox(NextInspection, 'NextInspection', 16 )" style="margin-left: 15px;">
              Next Inspect
            </mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="LastInspection" (change)="changeCheckbox(LastInspection, 'LastInspection', 17 )" style="margin-left: 15px;">
              Last Inspect
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox class="example-margin" [(ngModel)]="Flag" (change)="changeCheckbox(Flag, 'Flag', 18 )" style="margin-left: 15px;">
              Flag
            </mat-checkbox>
        </div>
        </div>

      </div>
      <mat-table [dataSource]="dataSource1" matSort (matSortChange)="onSortChange($event)" class="table-material table-material--striped table-material--hover table-material--full-width">
        <ng-container matColumnDef="condition">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header style="margin-left: 1px;">
            {{'Worn(%)'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <span>
              <div class="{{getEvalClass(element.condition)}}"> {{element.condition}}%</div>
            </span>

          </mat-cell>
        </ng-container>


        <ng-container matColumnDef="Customer">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Customer'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText"> {{element.customer}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Jobsite">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Job Site'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText"> {{element.jobsite}} </div>
          </mat-cell>

        </ng-container>
        <ng-container matColumnDef="Make">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Make'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText"> {{element.make}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="AssetType">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Asset Type'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText"> {{element.AssetType}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="AssetDefinition">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
           {{'Asset  Definition'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText">{{element.type}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SerialNo">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Serial Number'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.serialNo}}" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText">{{element.serialNo}} </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="AdditionalSerial">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Alt.Serial'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText">{{element.AdditionalSerial}} </div>
          </mat-cell>
        </ng-container>




        <ng-container matColumnDef="ImpBudget">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Imp.Budget'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText"> {{element.ImpBudget}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Life">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Life'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText"> {{element.Life}} </div>
          </mat-cell>
        </ng-container>



        <ng-container matColumnDef="Residual">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header
          style="padding-left: 30px !important;">
            {{'Residual'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" 
          (click)="openImplementDetails(element.implementId)"style="
          text-align: left;
          padding-left: 30px !important;!i;!;
      ">
            <!-- <span> -->
              <!-- <div class="{{getColour(element.Residual,element.Life, element.ImpBudget)}}"> {{element.Residual}}</div> -->
            {{element.Residual}}
            <!-- </span> -->

          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="TotalLife">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Total Life'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <span>
              <div class="{{getColour(element.Residual,element.Life, element.ImpBudget)}}" title="Red - means life of asset is below budget. Green - means life of asset above budget"> {{element.TotalLife}}</div>
            </span>

          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="RemovelDate">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
            {{'Replace Date'| translate | async}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell" (click)="openImplementDetails(element.implementId)">
            <div class="SerialAndUnitText"> {{element.RemovelDate}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>  {{'Status'| translate | async}}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell">
            <div *ngIf="element.status=='On Equipment'" class="SerialAndUnitText"
                 (click)="openImplementDetails(element.implementId)"> {{element.equipment_unitno}} </div>
            <div class="SerialAndUnitText" *ngIf="element.status!='On Equipment'"> {{element.status}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="WarrantyStatus">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>{{'Warranty Status'| translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell">
            <ng-container *ngIf="element.hasWarranty">
              <div *ngIf="element.warrantyStatus" class="SerialAndUnitText"> Expired </div>
              <div class="SerialAndUnitText" *ngIf="!element.warrantyStatus"> {{element.ResidualHours}}hours\{{element.ResidualDays}}days </div>
            </ng-container>


          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BuildNo">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>{{'Build No'| translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell">
            <ng-container *ngIf="element.BuildNo">
              <div class="SerialAndUnitText"> {{element.BuildNo}} </div>
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NextInspection">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>{{'Next Inspect'| translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell">
            <ng-container *ngIf="element.NextInspection != '1900-01-01T00:00:00' && element.NextInspection!=null">
              <div class="SerialAndUnitText"> {{element.NextInspection| date : 'dd MMM yyyy'}} </div>
            </ng-container>
            <ng-container *ngIf="element.NextInspection == '1900-01-01T00:00:00' || element.NextInspection==null">
              <div class="SerialAndUnitText"> - </div>
            </ng-container>


          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="LastInspection">
          <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>{{'Last Inspect'| translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tableCell">
            <ng-container *ngIf=" element.LastInspection!=null">
              <div class="SerialAndUnitText"> {{element.LastInspection| date : 'dd MMM yyyy'}} </div>
            </ng-container>
            <ng-container *ngIf="element.LastInspection==null">
              <div class="SerialAndUnitText"> - </div>
            </ng-container>


          </mat-cell>
        </ng-container>


        <ng-container matColumnDef="Flag">
          <mat-header-cell class="headerCell" *matHeaderCellDef mat-sort-header>{{'Flag' | translate | async}} </mat-header-cell>
          <mat-cell class="tableCell" *matCellDef="let element">
              <div style="display: flex;">

                  <div class="menutoggle" *ngIf="element.InspectionFlag!=0" (click)="OpenInspectionPage(element.equipmentId, element.LastInspectionId)">
                    
                    <i  *ngIf="element.InspectionFlag!=0" class="material-icons button__icon"
                    style="font-size: 35px; vertical-align: middle;margin-top: -13%; cursor: context-menu; color: red;"
                          title="Click to Open Inspection Page">flag</i>
                          <span class="badge">{{element.InspectionFlag}}</span> 
                  </div>

              </div>


          </mat-cell>
      </ng-container>

        <mat-row *matRowDef="let row; columns: displayedColumns; " style="cursor: pointer;"></mat-row>
        <mat-header-row *matHeaderRowDef="displayedColumns; " style="position: sticky; "></mat-header-row>
      </mat-table>
      <mat-paginator [length]="recordCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                     (page)="onUserPaginateChange($event)">
      </mat-paginator>

    </div>
</div>
